import { css } from 'styled-system/css';

export const betTicketStyle = {
	ticket: css({
		base: {
			'& .banner-container': {
				borderRadius: '3px',
				margin: '6px 0 0 0',
			},
		},
		_mars: {
			borderBottomWidth: '1px',
			borderStyle: 'solid',
			color: 'black.2',
			borderColor: 'black.5',
			bgColor: 'var(--other-lv2)',
			'& .ticket__payout-amount': {
				color: 'secondary.500',
			},
			'& .ticket__number': {
				color: 'whiteOpacity.100',
				bgColor: '#EC6363',
			},
		}
	}),
	choice: css({
		_mars: {
			fontSize: '16px',
			color: 'black.1',
		}
	}),
	goal: css({
		_mars: {
			color: 'black.2',
			fontSize: '13px',
			fontWeight: '500',
			'& [data-change="true"]': {
				color: 'secondary.500',
			}
		},
	}),
	bettype: css({
		_mars: {
			color: 'black.2',
		},
	}),
	score: css({
		_mars: {
			color: 'secondary.500',
			fontSize: '16px',
			lineHeight: '1em',
		},
	}),
	teamName: css({
		_mars: {
			color: 'black.1',
			fontSize: '14px',
			fontWeight: '400',
		}
	}),
};